import styles from './style.module.scss';
import {Box, Typography} from '@mui/material';
import {t} from 'i18next';

type AurAskLioHiProps = {
  show: boolean;
};

const AurAskLioHi: React.FC<AurAskLioHiProps> = ({show}) => {
  let body: React.ReactNode = null;
  if (show) {
    body = (
      <>
        <Box className={`${styles.aurBoxStart}`}>
          <Typography className={`${styles.aurAskLioHiTypography}`}>
            {t('askLio.AskLioHi')}
          </Typography>
        </Box>
      </>
    );
  }
  return body;
};

export default AurAskLioHi;
